import type { ReactNode } from 'react';

/**
 * Container für vollbreite Routen-Seiten (Kalender, Admin, Profil, Anträge,
 * Dokumente): eigener Scroll-Container im Spalten-Layout, innen die alte
 * zentrierte max-w-7xl-Breite. Auch Wrapper für die Fallback-Seiten der
 * ProtectedRoutes innerhalb der Shell (z. B. ModuleDisabledPage).
 */
export function PageContainer({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-w-0 flex-1 flex-col overflow-y-auto">
      <div className="mx-auto w-full max-w-7xl px-4 py-6 sm:px-6">{children}</div>
    </div>
  );
}